<template>
  <div class="video-detail maxW">
    <BreadCrumb
      v-if="videoDetail"
      :currentCate="videoDetail.cate_name"
      :currentVideo="videoDetail.name"
    />

    <section class="video-player">
      <header class="player-header">
        <div class="header-name"><img
            class="backbtn"
            @click="goHome"
            src="@/assets/images/customer/guide-icon.png"
            alt=""
          >{{ videoDetail ? videoDetail.name : ' ' }}</div>
        <div
          class="header-copyright"
          @click="copyRightFlag = true"
        >{{ $t('global.warningTitle') }}
          <i class="el-icon-warning-outline" />
        </div>
      </header>
      <div class="player-content">
        <DPlayer
          ref="dplayer"
          :showTest="!videoDetail?.sources_id"
          v-if="videoDetail"
          :options="videoDetail"
          :pointData="pointData"
          @pause="handlePause" @play="handlePlay" @end="handleEnd" 
          @getVideoCountTime="countTime()"
          @notCountTime="notCountTime()"
        />
      </div>
    </section>

    <section class="video-count">
      <div>
        <img
          src="@/assets/images/customer/see.png"
          alt=""
        >
        <div>{{ videoDetail ? videoDetail.clicks + $t('customer.unit1'): '' }}</div>
      </div>
      <div>
        <img
          class="adjust"
          src="@/assets/images/customer/pinglun.png"
          alt=""
        >
        <div>{{ commentLength + $t('customer.unit2') }}</div>
      </div>
    </section>

    <section class="video-info">
      <div class="info-left" style="margin-right: 30px">
        <el-tabs type="border-card">
          <el-tab-pane :label="$t('homepage.classIntr')">
            <div
              class="intr-item"
              v-for="(item, index) in intrArr"
              :key="index"
              :class="{'hidden-item': !(item.content || item.label === $t('homepage.videoIntr'))} "
            >
              <template v-if="item.content || item.label === $t('homepage.videoIntr')">
                <div class="item-label">{{ item.label }}</div>
                <div
                  class="item-content"
                  v-if="item.content && item.content.includes('</')"
                  v-html="item.content"
                >
                </div>
                <div
                  class="item-content"
                  v-else
                >{{ item.content ? item.content : $t("global.noData") }}</div>
              </template>

            </div>
          </el-tab-pane>
          
          <el-tab-pane :label="$t('homepage.comment')">
            <Review @changeCount="changeCount" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div
        class="info-right"
      >
        <header>
          <img
            src="@/assets/images/customer/download.png"
            alt="download"
          >
          {{ $t('homepage.downloadRes') }}
        </header>
        <div class="file-content" v-if="!videoDetail?.sources_id">
          <div
            class="content-placeholder"
            v-if="fileArr.length===0"
          >{{ $t('customer.noData') }}</div>
          <div
            class="file-item"
            v-for="item in fileArr"
            :key="item.res_id"
            @click="downloadFile(item.id)"
          >
            <div class="item-name">{{ item.name }}</div>
            <div class="item-download"><i class="el-icon-download"></i></div>
          </div>
        </div>
      </div>
    </section>

    <CopyRight
      v-if="copyRightFlag"
      @closeCopyRight="copyRightFlag=false"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoDetail: null,
      pointData: null,
      copyRightFlag: false,
      commentLength: 0,

      copyright_show: null,

      countTimeForm: {
        video_id: this.$route.query.videoid,
        user_id: this.$g.user_id,
        total_time: 10,
        source: 1,
        ticket: "",
      },
    };
  },
  components: {
    BreadCrumb: () => import("./detail-comp/breadcrumb.vue"),
    DPlayer: () => import("@/components/common/DPlayer"),
    Review: () => import("./detail-comp/review.vue"),
    CopyRight: () => import("@/components/common-v2/copyRight.vue"),
  },
  computed: {
    intrArr() {
      //  课程介绍数据处理
      let keyWordStr = "";
      let saveTime = "";
      // 关键词处理
      if (!this.videoDetail || !this.videoDetail.keywords) {
        keyWordStr = this.$t("global.nokeyword");
      } else {
        this.videoDetail.keywords.forEach((element, index) => {
          if (index < this.videoDetail.keywords.length) {
            if (index === this.videoDetail.keywords.length - 1) {
              keyWordStr += element;
            } else {
              keyWordStr += element + ", ";
            }
          }
        });
      }
      if (this.videoDetail) {
        switch (this.videoDetail.save_month) {
          case 0:
            saveTime = this.$t("global.forever");
            break;

          case 6:
            saveTime = this.$t("global.halfYear");
            break;

          case 12:
            saveTime = this.$t("global.oneYear");
            break;

          default:
            saveTime = this.videoDetail.save_month + this.$t("global.month");
            break;
        }
      }
      if (this.videoDetail && this.videoDetail?.sources_id !== 0) {
        //  sources_id !== 0关联的视频，不显示关键字和保存时间
        keyWordStr = "";
        saveTime = "";
      }
      return [
        {
          label: this.$t("global.keyword"),
          content: keyWordStr,
        },
        {
          label: this.$t("homepage.videoCate"),
          content:  this.videoDetail?.cate_name || this.$t("global.noData"),
        },
        {
          label: this.$t("global.keepTime"),
          content: saveTime,
        },
        {
          label: this.$t("customer.coursevalue"),
          content: this.videoDetail?.notice  || this.$t("global.noData"),
        },
        {
          label: this.$t("homepage.videoIntr"),
          content: this.videoDetail?.profile ||  this.$t("global.noData"),
        },
      ];
    },
    fileArr() {
      if (
        this.videoDetail &&
        this.videoDetail.attachment_info &&
        this.videoDetail?.sources_id === 0
      ) {
        //  sources_id === 0 为自主上传的视频，才显示视频附件
        return this.videoDetail.attachment_info;
      } else {
        return [];
      }
    },
  },
  created() {
    this.checkVideoAuth();
    this.getTicket();
    this.isOpenCopyRight();
    this.recordClickCount();
    this.getPointData();
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/customer-home" });
    },
    checkVideoAuth() {
      let success = (res) => {
        let islimit = res.data.islimit;
        // console.log(islimit);
        if (islimit === 1) {
          return;
        } else {
          this.$message.warning(this.$t("customer.noAuth"));
          this.$router.push({ path: "/customer-home" });
        }
      };
      this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
        params: {
          type: 1,
          type_id: this.countTimeForm.video_id,
          user_id: this.countTimeForm.user_id,
        },
        func: { success },
      });
    },
    getPointData() {
      let success = (data) => {
        let result = data.data;
        // console.log('res',result)
        if (result && result.point.length > 0) {
          let point = result.point; //打点的数据
          this.pointData = JSON.parse(
            JSON.stringify(point)
              .replace(/video_time/g, "time")
              .replace(/comment/g, "text")
          );
          // console.log('pointdata',this.pointData)
        }
      };
      this.$ajax({
        url: "api/video/video_point_list",
        method: "get",
        params: {
          videoid: this.countTimeForm.video_id,
        },
        func: {
          success: success,
        },
      });
    },

    handlePlay() {
      console.info('handlePlay')
      this.countTimeForm.total_time = 10
      this.timer && clearInterval(this.timer);
      this.countTime()
      this.$nextTick(() => {
        this.$refs.dplayer.handDisplayNone(true)
      })
    },

    handleEnd() {
      console.info('handleEnd')
      this.countTimeForm.total_time = 0
      clearInterval(this.timer);
    },

    handlePause() {
      clearInterval(this.timer);
      this.countTimeForm.total_time = 0
    },

    countTime() {
      this.timer = setInterval(() => {
        // 2023-4-14 后端说这两个要改成同时进行
        // if (sessionStorage.getItem("tencentCloud") == 0) {
        this.getVideoCountTime(); // 会议版——十秒统计一次观看时长
        // } else {
        this.getVideoView(); //商学院统计观看记录方法
        // }
      }, 10000);
    },
    notCountTime() {
      // clearInterval(this.timer);
    },

    //获取凭证
    getTicket() {
      let params = {
        video_id: this.countTimeForm.video_id,
        user_id: this.$g.user_id,
      };
      let success = (data) => {
        this.countTimeForm.ticket = data.data.ticket;
      };
      this.$ajax.get("api/video/video_views_count_ticket", {
        params: params,
        func: { success },
      });
    },

    //原会议版观看记录，这里改动
    getVideoCountTime() {
      let params = this.countTimeForm;
      let success = (res) => {
        // console.log(res, this.countTimeForm,'提交观看时间')
        this.view = !(res.data.status === false);
      };
      this.$ajax.post("api/video/video_views_count", params, {
        func: { success },
      });
    },

    //商学院观看记录，
    getVideoView() {
      let params = this.countTimeForm;
      let success = (res) => {
        // console.log('提交观看记录', res)
        this.view = !(res.data.status === false);
      };
      this.$ajax.post("api/video/video_views_company", params, {
        func: { success },
      });
    },
    changeCount(count) {
      this.commentLength = count;
    },
    async isOpenCopyRight() {
      let success = (res) => {};
      let [{ data: res1 }, { data: res2 }] = await Promise.all([
        this.$ajax.get("api/video/live_app_show", {
          params: {
            type: 4,
          },
          func: { success },
        }),
        this.$ajax.get("api/video/video", {
          params: {
            videoid: this.$route.query.videoid,
          },
          func: { success },
        }),
      ]);

      this.videoDetail = res2.data.data;
      this.copyright_show = res1.data.data.copyright_show;

      if (
        this.copyright_show === 1 &&
        this.videoDetail.copyright_status === 1
      ) {
        // 如果全局配置和单个视频配置均为1，那么自动开启版权声明
        this.copyRightFlag = true;
      } else {
        // 否则不打开
        this.copyRightFlag = false;
      }

    },
    downloadFile(id) {
      window.location.href =
        this.BASE_URL + "/index/openclass/download_video_file_huiyi?id=" + id;
    },
    recordClickCount() {
      let success = (data) => {};
      this.$ajax({
        url: "api/video/video_click",
        method: "post",
        data: {
          video_id: this.$route.query.videoid,
        },
        func: {
          success,
        },
      });
    },
  },

  destroyed() {
    clearInterval(this.timer);
    // this.getVideoCountTime();
  },

};
</script>

<style scoped lang='scss'>
.video-detail {
  .video-player {
    .player-header {
      display: flex;
      justify-content: space-between;
      padding: 1.2rem;
      background-color: #fff;
      box-shadow: 0px 2px 4px 0px rgba(195, 195, 195, 0.3);
      .header-name {
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 1.4rem;
        height: 1.4rem;
        .backbtn {
          position: relative;
          top: -3px;
          &:hover {
            cursor: pointer;
            opacity: 0.7;
          }
        }
      }
      .header-copyright {
        user-select: none;
        display: flex;
        font-size: 1.2rem;
        height: 1.4rem;
        align-items: center;
        &:hover {
          cursor: pointer;
          opacity: 0.7;
        }
        i {
          margin-left: 0.5rem;
          margin-top: 2px;
          font-size: 1.4rem;
        }
      }
    }

    .player-content {
      width: 100%;
      height: 674px;
      overflow: hidden;
      background-color: #000;
    }
  }

  .video-count {
    height: 4rem;
    line-height: 4rem;
    display: flex;
    div {
      display: flex;
      align-items: center;
      font-size: 1.2rem;
      color: #666666;
      img {
        width: 1.6rem;
        margin-right: 0.8rem;
      }
      .adjust {
        width: 1.4rem;
        margin-left: 3rem;
      }
    }
  }

  .video-info {
    display: flex;
    justify-content: space-between;

    .info-left {
      width: 100%;
      margin-bottom: 2rem;
      // box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
      .hidden-item {
        border-bottom: none !important;
      }
      .intr-item {
        display: flex;
        line-height: 4rem;
        border-bottom: 1px solid #efefef;
        font-size: 1.2rem;
        color: #666666;
        .item-label {
          width: 8rem;
        }
        .item-content {
          display: flex;
          align-items: center;
          width: calc(100% - 8rem);
          line-height: 2rem;
        }
      }
      :deep(.el-tabs--border-card) {
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
      }
      :deep(.el-tab-pane ){
        min-height: 380px;
      }
      :deep(.el-tabs__content) {
        padding: 3rem;
        padding-top: 1rem;
      }
      :deep(.el-tabs__header ){
        user-select: none;
        background-color: #fff;
      }
      :deep(.el-tabs__item) {
        width: 14rem;
        padding: 0 3rem;
        border: 1px solid #ddd;
        border-bottom: none;
        text-align: center;
        &:hover {
          color: #e62125;
        }
      }
      :deep(.is-active ){
        border-bottom: none;
        color: #e62125;
        font-weight: 700;
        font-size: 1.2rem;
      }
    }
    .info-right {
      width: 25%;
      background: #ffffff;
      height: 260px;
      // box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
      user-select: none;
      header {
        width: 100%;
        height: 3.2rem;
        display: flex;
        align-items: center;
        background: #2c2e3f;
        color: #fff;
        font-size: 1.2rem;
        img {
          margin: 0 1.3rem;
          width: 1.5rem;
          height: 1.5rem;
        }
      }
      .file-content {
        height: calc(100% - 3.2rem);
        overflow: auto;
        .content-placeholder {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1.2rem;
          color: #999999;
        }
        .file-item {
          margin: 0.5rem;
          padding: 0.5rem 0.8rem;
          display: flex;
          height: 3rem;
          justify-content: space-between;
          align-items: center;
          font-size: 1.2rem;
          i {
            font-size: 1.5rem;
          }
          &:hover {
            background: #e9ecf3;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
<style>
.el-popup-parent--hidden {
  overflow: hidden;
}
</style>
